import Vue from "vue";
import VueRouter from "vue-router";
import { RouteConfigSingleView } from "vue-router/types/router";
import Page from "../components/Page.vue";
import { VueConstructor } from "vue/types/umd";

export interface FileOptions {
  fullPath: string;
  icon?: string;
  name?: string;
  menu?: string;
  title?: string;
  keywords?: string[];
  hideInMenu?: boolean;
}
export interface PageInterface {
  html: string;
  isFile: boolean;
  options: FileOptions;
}
export interface PagesInterface {
  [key: string]: PageInterface;
}

export interface IconRouteConfig extends RouteConfigSingleView {
  icon?: string | null;
  fullPath?: string;
  menu?: string;
  hideInMenu?: boolean;
}

export interface Meta {
  title?: string;
  keywords?: string[];
}

export interface PageRoute {
  children: PageRoute[];
  path: string;
  fullPath: string;
  meta: Meta;
  icon?: string | null;
  isFile: boolean;
  component: VueConstructor;
}

let pages: PagesInterface;

function parseName(path: string): string {
  return path.charAt(0).toLocaleUpperCase() + path.substr(1).replace(/-/gi, " ");
}

function createTree(parts: string[], fullPath: string, current: PageRoute): any {
  if (parts.length === 0) {
    return current;
  }
  const part: string = parts.shift() as string;
  const found = current.children.find((route) => route.path === part);
  if (!found) {
    const routeConfig = pages[fullPath];
    const path = part;
    const created = {
      path,
      fullPath,
      name: routeConfig.options.name ? routeConfig.options.name : routeConfig.options.title,
      menu: routeConfig.options.menu ? routeConfig.options.menu : routeConfig.options.title,
      isFile: true,
      icon: routeConfig && routeConfig.options.icon ? routeConfig.options.icon : null,
      meta: {
        title: routeConfig.options.title,
        keywords: routeConfig.options.keywords ?? [],
      },
      children: [],
      hideInMenu: routeConfig.options.hideInMenu,
      component: Page,
    };
    current.children.push(created);
    createTree(parts, fullPath, created);
  } else {
    createTree(parts, fullPath, found);
  }
}

const root: PageRoute = {
  path: "/",
  fullPath: "/",
  children: [],
  isFile: false,
  meta: { title: "", keywords: [] },
  component: Page,
};

Vue.use(VueRouter);
let router: VueRouter;

function getNext(path: string) {
  const paths = Object.keys(pages);
  const index = paths.indexOf(path);
  const next = paths[index + 1];
  router.push(next);
  return pages[next];
}

export function getCurrentPageData() {
  let fullPath = router.currentRoute.fullPath;
  if (!fullPath) fullPath = "/";
  for (const path in pages) {
    if (path === fullPath) {
      const page = pages[path];
      return page.html ? page : getNext(path);
    }
  }
  return getNext(fullPath);
}
export default async function initializeRoutes(): Promise<VueRouter> {
  pages = await fetch("/pages.json").then((response) => response.json());
  for (const pagePath in pages) {
    const pathParts = pagePath.substring(1).split("/");
    createTree(pathParts, pagePath, root);
  }
  root.children = root.children.map((child) => {
    child.path = "/" + child.path;
    return child;
  });
  const routes: Array<IconRouteConfig> = root.children;
  router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
  });

  router.afterEach(() => {
    const title = router.currentRoute?.meta?.title || "GSTC";
    document.title = title + " gantt-schedule-timeline-calendar javascript (typescript) component";
  });

  return router;
}

export { pages, router };
